import RestApiModel from "@/api/Model/RestApiModel";

class SubmitQuotation extends RestApiModel {
  static getResourceEndpoint() {
    return '/SubmitQuotation';
  }
}

export default SubmitQuotation;
